import { render, staticRenderFns } from "./paymentOrderRecords.vue?vue&type=template&id=016f024e&scoped=true&"
import script from "./paymentOrderRecords.vue?vue&type=script&lang=js&"
export * from "./paymentOrderRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f024e",
  null
  
)

export default component.exports